import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
    return (
        <div className="terms-and-conditions-page">
            <h1>Terms and Conditions</h1>
            <div className="content">
                {/* Here you will add the text for your terms and conditions */}
                <article>
    <h1>Terms and Conditions for [Your Company Name]</h1>

    <p><strong>Last Updated: [Date]</strong></p>

    <h2>1. Introduction</h2>
    <p>Welcome to [Your Company Name]. These terms and conditions outline the rules and regulations for the use of [Your Company Name]'s Website, located at [Your Website URL]. By accessing this website, we assume you accept these terms and conditions. Do not continue to use [Your Website URL] if you do not agree to take all of the terms and conditions stated on this page.</p>

    <h2>2. Intellectual Property Rights</h2>
    <p>Other than the content you own, under these Terms, [Your Company Name] and/or its licensors own all the intellectual property rights and materials contained in this Website. You are granted a limited license only for purposes of viewing the material contained on this Website.</p>

    <h2>3. Restrictions</h2>
    <p>You are specifically restricted from:</p>
    <ul>
        <li>Publishing any Website material in any other media.</li>
        <li>Selling, sublicensing, and/or otherwise commercializing any Website material.</li>
        <li>Publicly performing and/or showing any Website material.</li>
        <li>Using this Website in any way that is or may be damaging to this Website.</li>
        <li>Using this Website in any way that impacts user access to this Website.</li>
    </ul>

    <h2>4. Your Content</h2>
    <p>In these Website Standard Terms and Conditions, "Your Content" shall mean any audio, video, text, images, or other material you choose to display on this Website. By displaying Your Content, you grant [Your Company Name] a non-exclusive, worldwide irrevocable, sub-licensable license to use, reproduce, adapt, publish, translate, and distribute it in any and all media.</p>

    <h2>5. No Warranties</h2>
    <p>This Website is provided "as is," with all faults, and [Your Company Name] expresses no representations or warranties, of any kind related to this Website or the materials contained on this Website.</p>

    <h2>6. Limitation of Liability</h2>
    <p>In no event shall [Your Company Name], nor any of its officers, directors, and employees, be held liable for anything arising out of or in any way connected with your use of this Website.</p>

    <h2>7. Indemnification</h2>
    <p>You hereby indemnify to the fullest extent [Your Company Name] from and against any and/or all liabilities, costs, demands, causes of action, damages, and expenses arising in any way related to your breach of any of the provisions of these Terms.</p>

    <h2>8. Severability</h2>
    <p>If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.</p>

    <h2>9. Variation of Terms</h2>
    <p>[Your Company Name] is permitted to revise these Terms at any time as it sees fit, and by using this Website, you are expected to review these Terms on a regular basis.</p>

    <h2>10. Assignment</h2>
    <p>The [Your Company Name] is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.</p>

    <h2>11. Entire Agreement</h2>
    <p>These Terms constitute the entire agreement between [Your Company Name] and you in relation to your use of this Website, and supersede all prior agreements and understandings.</p>

    <h2>12. Governing Law & Jurisdiction</h2>
    <p>These Terms will be governed by and interpreted in accordance with the laws of the State of [Your State/Country], and you submit to the non-exclusive jurisdiction of the state and federal courts located in [Your State/Country] for the resolution of any disputes.</p>

    <h2>Contact Information</h2>
    <p>If you have any inquiries or questions about these Terms and Conditions, please contact us at: [Your Contact Information].</p>
</article>
 {/* Continue adding paragraphs as needed */}
            </div>
        </div>
    );
}

export default TermsAndConditions;
